const Asterik = () => {
    return <span style={{ color: "#FF8787" }}>&nbsp;*</span>;
};

export default Asterik;
